import CFormItem from "./formItem.vue";
import CModal from "./modal.vue";
import CScrollbar from "./scrollbar.vue";
import CSelect from "./select.vue";
import CSwitch from "./switch.vue";
import CSwitchList from "./switchList.vue";
import CTrigger from "./trigger.vue";
import CHImage from "@/components/headImagePatient/index.vue";
import CBreadcrumb from "./breadcrumb.vue";
import CInputTriggerTag from "./inputTriggerTag.vue";

const Components = {
    CFormItem,
    CModal,
    CScrollbar,
    CSelect,
    CSwitch,
    CSwitchList,
    CTrigger,
    CHImage,
    CBreadcrumb,
    CInputTriggerTag,
};

export const registerComponents = (app) => {
    Object.keys(Components).forEach((key) => {
        app.component(key, Components[key]);
    });
};